import { render } from "./total_amount.vue?vue&type=template&id=0c2b7867"
import script from "./total_amount.vue?vue&type=script&lang=js"
export * from "./total_amount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__